import {QRCodeSVG} from "qrcode.react";
import {buildSpdString, SpdPaymentData} from "./buildSpdString";

interface PaymentQrCodeProps extends SpdPaymentData {
    size?: number;
    includePaymentId?: boolean;
}

function currentUnixTimestampSeconds(): number {
    return Math.floor(Date.now() / 1000);
}

function tryBuildSpdString(spdData: SpdPaymentData, paymentId?: number): string | null {
    try {
        return buildSpdString(spdData, paymentId);
    } catch (e) {
        console.error("PaymentQrCode: failed to build SPD string", e);
        return null;
    }
}

export function PaymentQrCode(props: Readonly<PaymentQrCodeProps>) {
    const {size = 200, includePaymentId, ...spdData} = props;
    const paymentIdTimestamp = includePaymentId ? currentUnixTimestampSeconds() : undefined;
    const spdString = tryBuildSpdString(spdData, paymentIdTimestamp);

    if (!spdString) return null;

    return <QRCodeSVG value={spdString} size={size} level="M"/>;
}
